import { getFilteredPermissionData } from '..';

const CAP_TABLE_IMPORT_MODULES = ['Securities', 'Convertible', 'Warrants'] as const;
const CAP_TABLE_IMPORT_ACTIONS = ['Create', 'Edit'] as const;

type PermissionEntry = { text?: string };

/**
 * User can access unified instrument import when they can create or edit
 * at least one cap table instrument type (securities, convertibles, or warrants).
 */
export function hasCapTableInstrumentImportAccess(
  grantedPolicies: Record<string, unknown> | undefined | null
): boolean {
  if (grantedPolicies == null) {
    return false;
  }

  const { nonFieldLevelPermissionsGroups } = getFilteredPermissionData(
    grantedPolicies,
    'CustomerService.Customer.'
  );

  return CAP_TABLE_IMPORT_MODULES.some((module) =>
    (nonFieldLevelPermissionsGroups[module] as PermissionEntry[] | undefined)?.some(
      (entry) =>
        entry.text != null &&
        (CAP_TABLE_IMPORT_ACTIONS as readonly string[]).includes(entry.text)
    )
  );
}
